export const SIZES = [
  { id: "small", label: "Small", example: "Fiat 500, Panda, Smart, Aygo" },
  { id: "medium", label: "Medium", example: "Golf, Audi A3, Classe A, 500X" },
  { id: "large", label: "Large", example: "BMW Serie 3/5, SUV compatti, Passat" },
  { id: "xlarge", label: "X Large", example: "SUV 7 posti, Van, Range Rover" },
];

export const PACKAGES = [
  {
    id: "base",
    name: "BASE",
    subtitle: "Pulizia ordinaria dell'abitacolo",
    description:
      "Aspirazione completa dell'abitacolo e del bagagliaio, pulizia accurata di tutte le superfici principali e facilmente accessibili. Perfetto per chi vuole un risultato impeccabile in tempi rapidi.",
    image:
      "https://images.unsplash.com/photo-1652510015643-8b1d54939ec4?crop=entropy&cs=srgb&fm=jpg&q=85",
    prices: { small: 60, medium: 70, large: 80, xlarge: 90 },
    features: [
      "Aspirazione completa abitacolo e bagagliaio",
      "Pulizia accurata delle superfici principali",
      "Igienizzazione punti facilmente accessibili",
      "Risultato impeccabile in tempi rapidi",
    ],
  },
  {
    id: "premium",
    name: "PREMIUM",
    badge: "Più richiesto",
    subtitle: "Pulizia profonda dell'abitacolo",
    description:
      "Pulizia minuziosa e profonda dell'auto, arrivando anche nei punti più nascosti e difficili da raggiungere. Include l'applicazione di un protettivo per plastiche e cruscotto contro i raggi UV: previene l'invecchiamento e dona una finitura satinata come nuova.",
    image:
      "https://images.unsplash.com/photo-1771491237218-cbd4a707497e?crop=entropy&cs=srgb&fm=jpg&q=85",
    prices: { small: 90, medium: 120, large: 150, xlarge: 180 },
    features: [
      "Pulizia minuziosa e profonda dell'abitacolo",
      "Raggiunge i punti più nascosti e difficili",
      "Protettivo plastiche e cruscotto anti raggi UV",
      "Previene l'invecchiamento delle superfici",
      "Finitura satinata come nuova",
    ],
  },
];

export const EXTRAS = [
  {
    id: "leather",
    name: "Trattamento sedili in pelle",
    description: "Nutrizione e protezione delle pelli per un aspetto curato e duraturo.",
    image:
      "https://images.unsplash.com/photo-1667893530449-e58102223524?crop=entropy&cs=srgb&fm=jpg&q=85",
    prices: { small: 10, medium: 20, large: 30, xlarge: 40 },
  },
  {
    id: "fabric",
    name: "Lavaggio sedili in tessuto",
    description: "Smacchiatura e lavaggio profondo della tappezzeria in tessuto.",
    image:
      "https://images.pexels.com/photos/5233264/pexels-photo-5233264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    prices: { small: 30, medium: 40, large: 50, xlarge: 60 },
  },
];

export const REVIEWS = [
  { id: 1, name: "Martina R.", city: "Bressanone", car: "Audi Q5", rating: 5, text: "Interni come nuovi, è venuto direttamente in ufficio mentre lavoravo. Preciso, puntuale e gentilissimo." },
  { id: 2, name: "Luca B.", city: "Chiusa", car: "Volkswagen Golf", rating: 5, text: "Pacchetto Base fatto in tempi rapidi, l'auto profuma di pulito e non c'è più un granello di polvere. Consigliato!" },
  { id: 3, name: "Sara M.", city: "Bolzano", car: "Fiat 500", rating: 5, text: "Il lavaggio dei sedili in tessuto ha tolto macchie che pensavo impossibili. Servizio a domicilio comodissimo." },
  { id: 4, name: "Andreas H.", city: "Vipiteno", car: "BMW Serie 3", rating: 5, text: "Premium con trattamento pelle: cruscotto satinato e sedili morbidi come il primo giorno. Rapporto qualità/prezzo ottimo." },
];

export const TIME_SLOTS = [
  "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
];

// Giorni di apertura: 5=venerdì, 6=sabato, 0=domenica (Date.getDay())
export const DAY_SLOTS = {
  5: ["13:00", "14:00", "15:00", "16:00", "17:00"],
  6: ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00"],
  0: ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00"],
};

export const slotsForDate = (dateStr) => {  if (!dateStr) return [];
  const [y, m, d] = dateStr.split("-").map(Number);
  return DAY_SLOTS[new Date(y, m - 1, d).getDay()] || [];
};

export const OPENING_LABEL = "Venerdì 13:00-17:00 · Sabato e Domenica 08:00-17:00";

export const CONTACT = {
  phone: "+39 352 048 7880",
  phoneHref: "+393520487880",
  whatsapp: "393520487880",
  email: "cosimiroclean@icloud.com",
  area: "Servizio esclusivamente a domicilio e in azienda - da Bressanone (BZ), entro 40 km gratis",
  instagram: "https://www.instagram.com/cosimiroclean",
  facebook: "https://www.facebook.com/",
};
